import script from "./dummyData6.vue?vue&type=script&lang=js"
export * from "./dummyData6.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__